var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pages_content"},[_c('div',{staticClass:"imgcenter"},[_c('img',{attrs:{"src":require("@/assets/ICPSindex.png")}})])])
}]

export { render, staticRenderFns }